import { RootStore } from "./reducers";

const initialState: RootStore = {
  home: {
    subMenuOpened: false,
    mainMenuList: [
      {
        id: 0,
        title: "产品",
        active: false,
        children: [
          {
            id: 0,
            title: "清洁凝露",
            active: false,
            children: [
              {
                id: 0,
                title: "头皮净洁凝露（夏）",
                active: false,
              },
              {
                id: 1,
                title: "头皮净洁凝露（冬）",
                active: false,
              },
            ],
          },
          {
            id: 1,
            title: "洗发水",
            active: false,
            children: [
              {
                id: 0,
                title: "净屑安肌洗发水",
                active: false,
              },
              {
                id: 1,
                title: "舒缓水润洗发水",
                active: false,
              },
              {
                id: 2,
                title: "绚色恒护洗发水",
                active: false,
              },
              {
                id: 3,
                title: "健发赋活洗发水",
                active: false,
              },
              {
                id: 4,
                title: "平衡净油洗发水",
                active: false,
              },
            ],
          },
          {
            id: 2,
            title: "护发乳",
            active: false,
            children: [
              {
                id: 0,
                title: "沁活丝滑护发乳",
                active: false,
              },
              {
                id: 1,
                title: "舒缓水润护发乳",
                active: false,
              },
              {
                id: 2,
                title: "绚色恒护护发乳",
                active: false,
              },
              {
                id: 3,
                title: "健发强韧护发乳",
                active: false,
              },
              {
                id: 4,
                title: "平衡轻盈护发乳",
                active: false,
              },
            ],
          },
          {
            id: 3,
            title: "精华膜",
            active: false,
            children: [
              {
                id: 0,
                title: "奢耀修护头发精华膜",
                active: false,
              },
              {
                id: 1,
                title: "箐纯蓓润头发精华膜",
                active: false,
              },
            ],
          },
          {
            id: 4,
            title: "原萃液",
            active: false,
            children: [
              {
                id: 0,
                title: "沁活安肌头皮原萃液",
                active: false,
              },
              {
                id: 1,
                title: "舒缓水润头皮原萃液",
                active: false,
              },
              {
                id: 2,
                title: "绚色恒护头皮原萃液",
                active: false,
              },
              {
                id: 3,
                title: "健发赋活头皮原萃液",
                active: false,
              },
              {
                id: 4,
                title: "平衡净油头皮原萃液",
                active: false,
              },
            ],
          },
          {
            id: 5,
            title: "精华液",
            active: false,
            children: [
              {
                id: 0,
                title: "净屑安肌头皮精华液",
                active: false,
              },
              {
                id: 1,
                title: "舒缓水润头皮精华液",
                active: false,
              },
              {
                id: 2,
                title: "绚色恒护头皮精华液",
                active: false,
              },
              {
                id: 3,
                title: "健发赋活头皮精华液",
                active: false,
              },
              {
                id: 4,
                title: "平衡净油头皮精华液",
                active: false,
              },
            ],
          },
          {
            id: 6,
            title: "按摩精华油",
            active: false,
            children: [
              {
                id: 0,
                title: "舒润活源肩颈按摩精华油",
                active: false,
              },
              {
                id: 1,
                title: "悦活珍萃精华油",
                active: false,
              },
            ],
          },
          {
            id: 7,
            title: "精华喷雾",
            active: false,
            children: [
              {
                id: 0,
                title: "琉光防护头发精华喷雾",
                active: false,
              },
              {
                id: 1,
                title: "丝柔光感发尾油",
                active: false,
              },
            ],
          },
          {
            id: 9,
            title: "高定香水",
            active: false,
            children: [
              {
                id: 0,
                title: "自由拾光香水",
                active: false,
              },
              {
                id: 1,
                title: "一生之水香水",
                active: false,
              },
              {
                id: 2,
                title: "我的秘密香水",
                active: false,
              },
              {
                id: 3,
                title: "悦粲星光香水",
                active: false,
              },
              {
                id: 4,
                title: "活力倾澄香水",
                active: false,
              },
            ],
          },
        ],
      },
      { id: 1, title: "服务", active: false },
      { id: 2, title: "门店", active: false },
      { id: 3, title: "招商", active: false, url: "/investment" },
      { id: 4, title: "人才招聘", active: false },
      { id: 5, title: "新闻资讯", active: false },
      { id: 6, title: "关于我们", active: false },
    ],
  },
  demo: {
    count: 0,
  },
};

export default initialState;
